/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const StartPaymentCloseTabDataParser = 
/* #__PURE__ */ parsers.object([
    ['mode', /* #__PURE__ */ parsers.exactly('close_tab')],
]);
export class StartPaymentCloseTabData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return StartPaymentCloseTabDataParser.decode(input).map(res => new StartPaymentCloseTabData(res));
    }
    static unsafeDecode(input) {
        return StartPaymentCloseTabData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return StartPaymentCloseTabDataParser.encode(data);
    }
    static schema() {
        return StartPaymentCloseTabDataParser.schema();
    }
}
